export function useAssetPath(relativePath: string) {
  return `${import.meta.env.BASE_URL}${relativePath}`;
}